import { render, staticRenderFns } from "./bill-payment-df-form.vue?vue&type=template&id=a2754fb4&scoped=true"
import script from "./bill-payment-df-form.vue?vue&type=script&lang=js"
export * from "./bill-payment-df-form.vue?vue&type=script&lang=js"
import style0 from "./bill-payment-df-form.vue?vue&type=style&index=0&id=a2754fb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2754fb4",
  null
  
)

export default component.exports